import LegacyEntity from "%/dynamic-component-editor/classes/LegacyEntity";
import VerticalContainer from "%/dynamic-component-editor/standard-elements/layouts/VerticalContainer.vue";
import HorizontalContainer
  from "%/dynamic-component-editor/standard-elements/layouts/HorizontalContainer.vue";
import CarouselContainer from "%/dynamic-component-editor/standard-elements/layouts/CarouselContainer.vue";
import Container from "%/dynamic-component-editor/standard-elements/layouts/Container.vue";
import VerticalContainerWrapper
  from "%/dynamic-component-editor/standard-elements/layouts/VerticalContainerWrapper.vue";
import HorizontalContainerWrapper
  from "%/dynamic-component-editor/standard-elements/layouts/HorizontalContainerWrapper.vue";

export default class LegacyLayoutEntity extends LegacyEntity {

  static get elements() {
    return [
      VerticalContainerWrapper,
      HorizontalContainerWrapper,
      VerticalContainer,
      HorizontalContainer,
      CarouselContainer,
      Container,
    ];
  }
}
